import React from 'react';
import { IResourceComponentsProps, useTranslate } from '@refinedev/core';
import { useTable, List } from '@refinedev/antd';
import { Table } from 'antd';
import './../styles.css';
import { ColHeaderRight } from '@components/ColHeaderRight';
import { formatDate } from '../../Helpers';
export const ContactUsList: React.FC<IResourceComponentsProps> = () => {
  const translate = useTranslate();
  const { tableProps } = useTable({
    syncWithLocation: true,
  });

  return (
    <List title={translate('contact-us.title')}>
      <Table
        {...tableProps}
        rowKey="id"
        bordered={false}
        className="table"
        pagination={{
          position: ['bottomCenter'],
        }}
      >
        <Table.Column
          className="table-header"
          dataIndex="name"
          title={<ColHeaderRight title={translate('contact-us.name')} />}
          render={(value) => <span className="table-cell">{value}</span>}
          width={200}
        />
        <Table.Column
          className="table-header"
          dataIndex="phone_number"
          title={<ColHeaderRight title={translate('contact-us.phoneNumber')} />}
          render={(value) => <span className="table-cell">{value}</span>}
          width={200}
        />
        <Table.Column
          className="table-header"
          dataIndex="created_at"
          title={<ColHeaderRight title={translate('contact-us.sendingDate')} />}
          render={(value) => (
            <span className="table-cell">{formatDate(value)}</span>
          )}
          width={200}
        />
        <Table.Column
          className="table-header"
          dataIndex="message"
          title={<ColHeaderRight title={translate('contact-us.message')} />}
          render={(value) => (
            <span className="table-cell w-[100%]">{value}</span>
          )}
        />
      </Table>
    </List>
  );
};
